var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    className: "playIcon_svg__scale-110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.997 1.667c4.593 0 8.334 3.738 8.334 8.338 0 4.59-3.74 8.328-8.334 8.328s-8.333-3.738-8.333-8.328c0-4.6 3.74-8.339 8.333-8.339M9.048 6.69q-.265 0-.507.121c-.2.113-.361.29-.45.498a5 5 0 0 0-.145.587c-.088.475-.137 1.247-.137 2.099 0 .813.049 1.551.121 2.034.008.008.097.547.193.732.177.337.523.546.893.546h.032c.242-.008.748-.217.748-.225.853-.354 2.534-1.455 3.21-2.187l.048-.048c.088-.088.201-.225.225-.257a.97.97 0 0 0 .193-.586c0-.234-.072-.451-.209-.628-.032-.032-.153-.17-.265-.282-.66-.707-2.381-1.865-3.282-2.219-.137-.055-.483-.177-.668-.185"
  })));
};
export default SvgPlayIcon;